import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  imports: [],
  template: `
    <div
      class="modal fade"
      [id]="modalId"
      tabindex="-1"
      [attr.aria-labelledby]="modalId + 'Label'"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" [id]="modalId + 'Label'">
              ¿Quieres volver?
            </h1>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body">
            <p class="text-center">
              {{ message }}
            </p>

            <div
              class="d-flex flex-column flex-lg-row ustify-content-center gap-3 mt-4"
            >
              <button
                type="button"
                class="btn btn-secondary flex-fill"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>

              <button
                type="button"
                class="btn btn-primary flex-fill"
                data-bs-dismiss="modal"
                (click)="clicked.emit()"
              >
                Sí, volver
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``
})
export class ConfirmModalComponent {
  @Input({ required: true }) modalId?: string;
  @Input({ required: true }) message?: string;

  @Output() clicked = new EventEmitter<void>();
}
